export class Permission {
    id = null;

    claimName = '';

    claimAction = '';

    claimCategory = '';
}
